import { IdealUser } from 'authentication-data';
import { PUNCHOUT_JWT_BUYER_COOKIE_KEY, PUNCHOUT_JWT_RETURN_URL_KEY, PUNCHOUT_JWT_SESSION_ID_KEY } from './constants';

export class PunchoutUser extends IdealUser {
  public get buyerCookie(): string {
    const data = (this._data.profile[PUNCHOUT_JWT_BUYER_COOKIE_KEY] as string) ?? [];
    return Array.isArray(data) ? data[0] : data;
  }
  public get returnUrl(): string {
    const data = (this._data.profile[PUNCHOUT_JWT_RETURN_URL_KEY] as string) ?? [];
    return Array.isArray(data) ? data[0] : data;
  }
  public get sessionId(): string {
    const data = (this._data.profile[PUNCHOUT_JWT_SESSION_ID_KEY] as string) ?? [];
    return Array.isArray(data) ? data[0] : data;
  }

  /**
   * The real punchout buyer's email, sourced from the PunchOutSetupRequest
   * UserEmail extrinsic. Only present when the punchout session carried buyer identity.
   */
  public get punchoutUserEmail(): string | undefined {
    return this.email;
  }

  /**
   * The real punchout buyer's name, sourced from the PunchOutSetupRequest
   * UserName extrinsic. Only present when the punchout session carried buyer identity.
   */
  public get punchoutUserName(): string | undefined {
    return this.name;
  }

  public override toJSON() {
    return {
      ...super.toJSON(),
      buyerCookie: this.buyerCookie,
      returnUrl: this.returnUrl,
      sessionId: this.sessionId,
    };
  }
}
